import React, { useState } from "react";


interface DeleteAccountModalContentProps {
  onCancel: () => void;
  onDelete: (text: string) => void;
}

const DeleteAccountModalContent: React.FC<DeleteAccountModalContentProps> = ({ onCancel, onDelete }) => {
  const [text, setText] = useState("");

  return (
    <div className="w-full max-w-md p-6 text-white ">
      <div className="text-lg font-bold ">Удалить аккаунт?</div>
      <div className="text-left  py-3 text-base font-normal w-full">Введите "Удалить" для подтверждения</div>
      <div className="text-left py-3 text-base font-normal">
        <input type="text" className="w-full px-4  bg-transparent border-b border-white/30 text-white" placeholder="Введите слово" value={text} onChange={(e) => setText(e.target.value)} />
      </div>
      <div className="flex justify-end pt-4">
        <button className={`text-left px-6 py-3 text-base font-normal pt-2 pb-2  text-center `} onClick={onCancel}>Отмена</button>
        <button className="text-left px-6 py-3 text-base font-normal pt-2 pb-2  text-center" onClick={() => onDelete(text)}>Удалить</button>
      </div>
    </div>
  );
};

export default DeleteAccountModalContent; 
